import type { NumberSettings } from '../types';
import { checkIsIntlCurrencyCode } from './checkIsIntlCurrencyCode';

/*
Для кода, который Intl не считает валютой, style: 'currency' бросает RangeError,
поэтому откатываемся на style: 'decimal' — число без символа валюты,
с minimumFractionDigits: 0.
*/
export const buildCurrencyFormatOptions = (
    settings: NumberSettings,
    defaultMinFractionDigits: number,
    defaultMaxFractionDigits: number,
): Intl.NumberFormatOptions => {
    if (checkIsIntlCurrencyCode(settings.currency)) {
        const style = settings.hideCurrencySymbol ? 'decimal' : 'currency';

        return {
            minimumFractionDigits: settings.minimumFractionDigits ?? defaultMinFractionDigits,
            maximumFractionDigits: settings.maximumFractionDigits ?? defaultMaxFractionDigits,
            style,
            currencyDisplay: 'narrowSymbol',
            currency: settings.currency,
            roundingMode: 'halfEven',
        }
    }

    // bonuses and other "stuff"
    return {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
        style: 'decimal',
        roundingMode: 'floor',
    }
};
